import { Extension } from '@tiptap/core'

/**
 * Enter submits via injected getter (reads latest handler without recreating extensions).
 * Shift+Enter inserts a hard break within the paragraph.
 */
export const ComposerEnterSubmit = Extension.create({
  name: 'composerEnterSubmit',

  addOptions() {
    return {
      /** @returns {(() => void) | undefined} */
      getOnEnter: () => undefined,
    }
  },

  addKeyboardShortcuts() {
    return {
      Enter: () => {
        if (!this.editor.isEditable) return true
        const fn = this.options.getOnEnter?.()
        fn?.()
        return true
      },
      'Shift-Enter': () => this.editor.commands.setHardBreak(),
    }
  },
})
